import React from "react";
import { Icon, Menu } from "antd";
import { Link } from "react-router-dom";
import * as routes from "../constants/routes";
import LogoutButton from "./LogoutButton";


const { SubMenu } = Menu;

const MenuItem = ({ condition, to, icon, text, ...props }) => (
    condition ? (
        <Menu.Item {...props}>
            <Link to={to}>
                <Icon type={icon} /> <span>{text}</span>
            </Link>
        </Menu.Item>
    ) : null
);

const CocaColaMenu = ({ state, handleClick, onOpenChange }) => (
    <Menu
        onClick={handleClick}
        openKeys={state.openKeys}
        mode="inline"
        theme="light"
        inlineCollapsed={state.collapsed}
        onOpenChange={onOpenChange}
        className="menu"
    >
        <MenuItem key="home" to="/" icon="home" text="Home" condition={true} />
        <SubMenu
            key="main-stores"
            title={<span><Icon type="bank" /><span>Mi Tienda sin Residuos</span></span>}
        >
            <MenuItem to={routes.STORES_ANALYTICS} icon="stock" text="Análisis de datos" condition={true} />
            <MenuItem to={routes.STORES_WEIGHTS_PAGE} icon="gold" text="Pesos" condition={true} />
            <MenuItem key="stores_deliveries" to={routes.STORE_DELIVERIES} icon="team" text="Entregas de material" condition={true} />
            <MenuItem to={routes.STORES_DELIVERIES_REQUESTS} icon="pic-right" text="Recolecciones Tiendas" condition={true} />
            <MenuItem to={routes.TSR_USERS} icon="contacts" text="Usuarios TSR" condition={true} />
        </SubMenu>
        <Menu.Item key="logout">
            <LogoutButton />
        </Menu.Item>
    </Menu>
);

const PremiumClientMenu = ({ state, handleClick, onOpenChange }) => (
    <Menu
        onClick={handleClick}
        openKeys={state.openKeys}
        mode="inline"
        theme="light"
        inlineCollapsed={state.collapsed}
        onOpenChange={onOpenChange}
        className="menu"
    >
        <MenuItem key="home" to="/" icon="home" text="Home" condition={true} />
        <MenuItem key="deliveries" to={routes.PREMIUM_CLIENTS_DELIVERIES} icon="home" text="Recolecciones" condition={true} />
        <Menu.Item key="logout">
            <LogoutButton />
        </Menu.Item>
    </Menu>
);

const PrincipalMenu = ({ state, handleClick, onOpenChange }) => {
    const {
        collapsed,
        openKeys,
        admin,
        role,
        category,
        cityRole,
        cocaCola,
        premiumClient,
    } = state;

    /* 
    * NOTE: 
    * role = "superAdmin" | "admin" | "cityAdmin"
    * category = "all" | "operative" | "reciapp" | "administration"
    * cityRole = "all" | "Quito" | "Guayaquil" | "Cuenca" | "Tulcan" | "Bogota" | "Medellin" | "Otra"
    */

    const isSuperAdmin = admin && role === "superAdmin";
    const isAdminOrSuper = admin && (role === "superAdmin" || role === "admin");

    // Categorías
    const isAllCategory = category === "all";
    const isOperativeCategory = category === "operative";
    const isAdministrationCategory = category === "administration";

    // Combinaciones categoría + admin
    const isAdminAllOrOperative = admin && (isAllCategory || isOperativeCategory);

    // Combinaciones role + categoría
    const isAdminSuperOperative = isAdminOrSuper && (isAllCategory || isOperativeCategory);
    const isAdminSuperAdministration = isAdminOrSuper && (isAllCategory || isAdministrationCategory);

    // Ciudad
    const isCommonCities = cityRole === "Quito" || cityRole === "Guayaquil" || cityRole === "Cuenca";
    const isAllOrCommonCities = cityRole === "all" || isCommonCities;

    const RECIAPP_MENU_ITEMS = [
        {
            key: "all-users",
            route: routes.USERS,
            icon: "user",
            text: "Usuarios registrados",
        },
        {
            key: "deliveries",
            text: "Entregas",
            icon: "shopping",
            subItems: [
                { key: "deliveries-recycler", route: routes.DELIVERIES, text: "Recicladores", condition: admin },
                { key: "deliveries-stations", route: routes.RECYCLING_STATIONS_DELIVERIES, text: "Estaciones de reciclaje", condition: isAdminSuperOperative },
                { key: "deliveries-ca", route: routes.CA_DELIVERIES, text: "Centros de Acopio", condition: isAdminAllOrOperative }
            ],
        },
        {
            key: "profiles",
            text: "Pefiles",
            icon: "team",
            subItems: [
                { key: "recyclers", route: routes.RECYCLERS, text: "Recicladores", condition: admin },
                { key: "stations", route: routes.RECYCLING_STATIONS, text: "Actores App", condition: isAdminSuperOperative },
                { key: "campaigns-allies", route: routes.CAMPAIGNS_PARTNERS, text: "Campañas Aliados", condition: isAdminAllOrOperative },
            ],
        },
        {
            key: "commerces-exchanges",
            text: "Gamificación",
            icon: "appstore",
            subItems: [
                { key: "commerces", route: routes.COMMERCE, text: "ReciNegocios", condition: isAdminAllOrOperative },
                { key: "exchanges", route: routes.EXCHANGES, text: "Canjes", condition: isAdminAllOrOperative },
                { key: "recyclers-exchanges", route: routes.RECYCLERS_EXCHANGES, text: "Canjes recicladores", condition: isAdminAllOrOperative },
                { key: "exchange-points", route: routes.EXCHANGE_POINTS, text: "Puntos de canje", condition: isAdminAllOrOperative },
            ],
        },
        {
            key: "settings",
            text: "Funciones APP",
            icon: "appstore",
            subItems: [
                { key: "cities", route: routes.CITIES, text: "Ciudades", condition: isSuperAdmin },
                { key: "wawd", route: routes.WHAT_ARE_WE_DOING, text: "¿Qué estamos haciendo?", condition: isAdminAllOrOperative },
                { key: "recitips", route: routes.RECITIPS, text: "ReciTips", condition: isAdminAllOrOperative },
                { key: "recyclers-events", route: routes.RECYCLERS_EVENTS, text: "Eventos recicladores", condition: isAdminAllOrOperative },
            ],
        },
        {
            key: "reports-reciapp",
            text: "Reportes",
            icon: "snippets",
            subItems: [
                { key: "active-user", route: routes.MOSTACTIVEUSERS, text: "Usuarios más activos", condition: isAdminSuperAdministration },
                { key: "use-habits", route: routes.HABITS, text: "Hábitos", condition: isAdminSuperAdministration },
                { key: "deliveries-recycler-report", route: routes.DELIVERIESFORRECYCLERS, text: "Entregas recicladores", condition: isAdminSuperAdministration },
            ],
        }
    ]

    const RECIRCULAR_MENU_ITEMS = [
        {
            key: "recircular-profiles",
            text: "Perfiles",
            icon: "team",
            subItems: [
                { key: "traceability-users", route: routes.TRACEABILITY_USERS, text: "Dashboards", condition: isSuperAdmin },
                { key: "gestors", route: routes.MANAGERS_TRACEABILITY, text: "Gestores", condition: isAdminAllOrOperative }
            ]
        },
        {
            key: "traceability",
            text: "Registro de pesos",
            icon: "snippets",
            subItems: [
                { key: "traceability-stations-transactions", route: routes.RECYCLING_STATIONS_WEIGHTS_PAGE, text: "Pesos estaciones", condition: isAdminAllOrOperative },
                { key: "traceability-stations", route: routes.RECICLATON_WEIGHTS_PAGE, text: "Pesos Recieventos", condition: isAdminAllOrOperative },
                { key: "traceability-reciapp-weights", route: routes.RECIAPP_WEIGHTS_PAGE, text: "Pesos ReciApp", condition: isAdminAllOrOperative },
                { key: "traceability-premium-weights", route: routes.PREMIUM_WEIGHTS_PAGE, text: "Pesos Recolecciones", condition: isAdminAllOrOperative },
            ]
        }
    ]

    const REPORTS_MENU_ITEMS = [
        {
            key: "analytics",
            subItems: [
                { key: "graphics-analysis", icon: "rise", route: routes.GRAPHICS_ANALYSIS, text: "Pesos estrategia", condition: isAdminAllOrOperative },
                { key: "analytics-material", icon: "stock", route: routes.GRAPHICS_ANALYSIS_MATERIAL, text: "Materiales", condition: isAdminAllOrOperative },

                { key: "analytics-recyclers", icon: "pie-chart", route: routes.RECYCLERS_ANALYSIS, text: "Recicladores", condition: isAdminAllOrOperative },
                { key: "graphics-materials-weights", icon: "rise", route: routes.MATERIALS_WEIGHTS_PER_STRATEGY, text: "Pesos materiales", condition: isAdminAllOrOperative },

            ]
        }
    ]

    const ADMIN_SETTINGS_MENU_ITEMS = [
        {
            key: "control-panel",
            icon: "bank",
            text: "Panel de control",
            subItems: [
                { key: "admin-cities", route: routes.ADMIN_CITIES, text: "Ciudades Admin" },
                { key: "users-super-admin", route: routes.SUPER_ADMINISTRATOR_USERS_PROFILES, text: "Perfiles de usuarios" },
                { key: "create-users-per-city", route: routes.CREATE_USERS_PER_CITY, text: "Perfiles por ciudad" },
                { key: "users-filtered", route: routes.FILTER_USERS, text: "Usuarios por ciudad" },
            ]
        }
    ]

    const HIDDEN_MENU_ITEMS = [
        {
            key: "hidden-menu",
            icon: "eye-invisible",
            text: "Funciones ocultas",
            subItems: [
                { key: "containers", route: routes.CONTAINERS, text: "Contenedores", condition: isAdminSuperOperative },
                { key: "users-tsr", route: routes.TSR_USERS, text: "Usuarios TSR", condition: isAdminSuperOperative },
                { key: "campaigns", route: routes.CAMPAIGNS, text: "Campañas", condition: isSuperAdmin },
                { key: "traceability-users-no-qr", route: routes.NO_QR_PROFILES, text: "Perfiles sin QR", condition: isAdminSuperOperative },
                { key: "traceability-iglus", route: routes.IGLUS, text: "Iglús", condition: isAdminAllOrOperative },
                { key: "traceability-pichaybots", route: routes.PICHAYBOTS, text: "Pichaybots", condition: isAdminAllOrOperative && (cityRole === "all" || cityRole === "Cuenca") },
                { key: "recyclerest-user", route: routes.MOSTRECYCLERUSER, text: "Usuarios más recicla", condition: isAdminSuperAdministration },
                { key: "deliveries-map", route: routes.DELIVERIESHEATMAP, text: "Mapa de entregas", condition: isAdminSuperAdministration },
                { key: "users-active", route: routes.ACTIVE_USERS, text: "Usuarios activos", condition: isSuperAdmin },
                { key: "store-analitycs", route: routes.STORES_ANALYTICS, text: "Datos tiendas", condition: admin && (isSuperAdmin || isOperativeCategory) },
                { key: "transformers", route: routes.TRANSFORMERS, text: "Transformadoras", condition: isSuperAdmin },
                { key: "collectors", route: routes.COLLECTORS, text: "Recolectores", condition: isSuperAdmin },
                { key: "intermediaries", route: routes.INTERMEDIARIES, text: "Intermediarios", condition: isSuperAdmin },
                { key: "associations", route: routes.ASSOCIATIONS, text: "Asociaciones", condition: isSuperAdmin },
                { key: "traceability-store-weights", route: routes.STORES_WEIGHTS_PAGE, text: "Pesos tiendas", condition: isAdminAllOrOperative },
                { key: "subscriptions", route: routes.SUBSCRIPTIONS, text: "Suscripciones", condition: isAdminSuperOperative },
                { key: "traceability-collectors-transactions", route: routes.TRACEABILITY_COLLECTORS_TRANSACTIONS, text: "Transacciones recolectores", condition: isSuperAdmin },
                { key: "analytics-stores", icon: "fund", route: routes.STORES_GRAPHICS, text: "Tiendas", condition: isAdminAllOrOperative },
                { key: "analytics-commerces", icon: "shop", route: routes.COMMERCE_REPORTS, text: "Comercios", condition: isAdminOrSuper },
            ]
        },
        {
            key: "recycling-routes",
            text: "Rutas de recolección",
            icon: "branches",
            subItems: [
                { key: "static-routes", route: routes.STATIC_ROUTES, text: "Rutas estáticas", condition: isAdminSuperOperative },
                { key: "static-routes-deliveries", route: routes.STATIC_ROUTES_DELIVERIES, text: "Entregas rutas estáticas", condition: isAdminSuperOperative },
                { key: "make-route", route: routes.MAKEROUTE, text: "Crear ruta", condition: isAdminAllOrOperative },
                { key: "request", route: routes.REQUESTS, text: "Solicitudes de recolección", condition: isAdminSuperOperative },
            ]
        }
    ]

    if (cocaCola) {
        return <CocaColaMenu state={state} handleClick={handleClick} onOpenChange={onOpenChange} />;
    }

    if (premiumClient) {
        return <PremiumClientMenu state={state} handleClick={handleClick} onOpenChange={onOpenChange} />;
    }

    return (
        <Menu
            onClick={handleClick}
            openKeys={openKeys}
            mode="inline"
            theme="light"
            inlineCollapsed={collapsed}
            onOpenChange={onOpenChange}
            className="menu"
        >
            <MenuItem key="home" to="/" icon="home" text="Home" condition={admin} />
            {/*RECIAPP*/}
            <SubMenu
                key="reciapp"
                title={<span><Icon type="mobile" /><span>ReciApp</span></span>}
            >
                <MenuItem key="all-users" to={routes.USERS} icon="user" text="Usuarios registrados" condition={isAdminOrSuper} />
                <SubMenu
                    key="deliveries"
                    title={<span><Icon type="shopping" /><span>Entregas</span></span>}
                >
                    {RECIAPP_MENU_ITEMS.find(item => item.key === "deliveries").subItems.map(item => (
                        <MenuItem key={item.key} to={item.route} text={item.text} condition={item.condition} />
                    ))}
                </SubMenu>
                <SubMenu
                    key="profiles"
                    title={<span><Icon type="team" /><span>Perfiles</span></span>}
                >
                    {RECIAPP_MENU_ITEMS.find(item => item.key === "profiles").subItems.map(item => (
                        <MenuItem key={item.key} to={item.route} text={item.text} condition={item.condition} />
                    ))}
                </SubMenu>
                <SubMenu
                    key="commerces-exchanges"
                    title={<span><Icon type="shop" /><span>Gamificación</span></span>}
                >
                    {RECIAPP_MENU_ITEMS.find(item => item.key === "commerces-exchanges").subItems.map(item => (
                        <MenuItem key={item.key} to={item.route} text={item.text} condition={item.condition} />
                    ))}
                </SubMenu>
                <SubMenu
                    key="settings"
                    title={<span><Icon type="appstore" /><span>Funciones APP</span></span>}
                >
                    {RECIAPP_MENU_ITEMS.find(item => item.key === "settings").subItems.map(item => (
                        <MenuItem key={item.key} to={item.route} text={item.text} condition={item.condition} />
                    ))}
                </SubMenu>
                <SubMenu
                    key="reports-reciapp"
                    title={<span><Icon type="snippets" /><span>Reportes</span></span>}
                >
                    {RECIAPP_MENU_ITEMS.find(item => item.key === "reports-reciapp").subItems.map(item => (
                        <MenuItem key={item.key} to={item.route} text={item.text} condition={item.condition} />
                    ))}
                </SubMenu>
            </SubMenu>

            {/*RECIRCULAR*/}
            <SubMenu
                key="recircular"
                title={<span><Icon type="file-sync" /><span>Registro de datos</span></span>}
            >
                <SubMenu
                    key="recircular-profiles"
                    title={<span><Icon type="team" /><span>Perfiles</span></span>}
                >
                    {RECIRCULAR_MENU_ITEMS.find(item => item.key === "recircular-profiles").subItems.map(item => (
                        <MenuItem key={item.key} to={item.route} text={item.text} condition={item.condition} />
                    ))}
                </SubMenu>
                <SubMenu
                    key="traceability"
                    title={<span><Icon type="snippets" /><span>Pesos</span></span>}
                >
                    {RECIRCULAR_MENU_ITEMS.find(item => item.key === "traceability").subItems.map(item => (
                        <MenuItem key={item.key} to={item.route} text={item.text} condition={item.condition} />
                    ))}
                </SubMenu>
            </SubMenu>

            {/*REPORTS*/}
            <SubMenu
                key="reports"
                title={<span><Icon type="bar-chart" /><span>KPIs</span></span>}
            >
                {REPORTS_MENU_ITEMS.find(item => item.key === "analytics").subItems.map(item => (
                    <MenuItem key={item.key} to={item.route} text={item.text} icon={item.icon} condition={item.condition} />
                ))}
            </SubMenu>

            {/*HIDDEN MENU*/}
            <SubMenu
                key="hidden-menu"
                title={<span><Icon type="eye-invisible" /><span>Funciones ocultas</span></span>}
            >
                {HIDDEN_MENU_ITEMS.map(item => (
                    <SubMenu key={item.key} title={<span><Icon type={item.icon} /><span>{item.text}</span></span>}>
                        {item.subItems.map(subItem => (
                            <MenuItem key={subItem.key} to={subItem.route} text={subItem.text} condition={isSuperAdmin} />
                        ))}
                    </SubMenu>
                ))}
            </SubMenu>

            {/*ADMIN SETTINGS*/}
            <SubMenu
                key="admin-settings"
                title={<span><Icon type="control" /><span>Panel de control</span></span>}
            >
                {ADMIN_SETTINGS_MENU_ITEMS.find(item => item.key === "control-panel").subItems.map(item => (
                    <MenuItem key={item.key} to={item.route} text={item.text} condition={isSuperAdmin} />
                ))}
            </SubMenu>

            {/*LOGOUT*/}
            <Menu.Item key="logout">
                <LogoutButton />
            </Menu.Item>
        </Menu>
    );
};

export default PrincipalMenu;
